import { History } from "history";
import {
  ADD_PLAN,
  ADD_PLAN_ERROR,
  ADD_PLAN_SUCCESS,
  AddPlanAction,
  AddPlanErrorAction,
  AddPlanSuccessAction,
  DELETE_PLAN,
  DELETE_PLAN_CONSENT,
  DELETE_PLAN_ERROR,
  DELETE_PLAN_SUCCESS,
  DeletePlanAction,
  DeletePlanConsentAction,
  DeletePlanErrorAction,
  DeletePlanSuccessAction,
  GET_PLAN,
  GET_PLAN_ERROR,
  GET_PLAN_SUCCESS,
  GET_PLANS,
  GET_PLANS_ERROR,
  GET_PLANS_SUCCESS,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS,
  GetPlanAction,
  GetPlanErrorAction,
  GetPlansAction,
  GetPlansErrorAction,
  GetPlansSuccessAction,
  GetPlanSuccessAction,
  GetPurchaseablePlansForStudentAction,
  GetPurchaseablePlansForStudentErrorAction,
  GetPurchaseablePlansForStudentSuccessAction,
  REMOVE_UPLOADED_PLAN_IMAGE,
  RemoveUploadedPlanImageAction,
  RESET_PURCHASEABLE_PLANS_FOR_STUDENT,
  ResetPurchaseablePlansForStudentAction,
  SET_INITIAL_PLAN_IMAGES,
  SetInitialPlanImagesAction,
  TOGGLE_ADD_EDIT_PLAN_MODAL,
  TOGGLE_PLAN_STATE,
  TOGGLE_PLAN_STATE_ERROR,
  TOGGLE_PLAN_STATE_SUCCESS,
  ToggleAddEditPlanModalAction,
  TogglePlanStateAction,
  TogglePlanStateErrorAction,
  TogglePlanStateSuccessAction,
  UPDATE_PLAN,
  UPDATE_PLAN_ERROR,
  UPDATE_PLAN_SUCCESS,
  UpdatePlanAction,
  UpdatePlanErrorAction,
  UpdatePlanSuccessAction,
  UPLOAD_PLAN_IMAGE,
  UPLOAD_PLAN_IMAGE_ERROR,
  UPLOAD_PLAN_IMAGE_PROGRESS,
  UPLOAD_PLAN_IMAGE_SUCCESS,
  UploadPlanImageAction,
  UploadPlanImageErrorAction,
  UploadPlanImageProgressAction,
  UploadPlanImageSuccessAction,
} from "./actionTypes";

import { PlanDto } from "../../interfaces/plan/plan.dto";
import { CreatePlanRequest } from "../../interfaces/plan";
import { MediaDto } from "../../interfaces/media";
import { UpdatePlanRequest } from "../../interfaces/plan/update-plan-request.interface";
import { SelectListDto } from "../../models";

//#region Get Plans

export const getPlans = (courseId: string, gradeId: string): GetPlansAction => {
  return {
    type: GET_PLANS,
    payload: { courseId, gradeId },
  };
};

export const getPlansSuccess = (response: PlanDto[]): GetPlansSuccessAction => {
  return {
    type: GET_PLANS_SUCCESS,
    payload: response,
  };
};

export const getPlansError = (error: any): GetPlansErrorAction => {
  return {
    type: GET_PLANS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Plan

export const getPlan = (id: string, history: History): GetPlanAction => {
  return {
    type: GET_PLAN,
    payload: { id, history },
  };
};

export const getPlanSuccess = (response: PlanDto): GetPlanSuccessAction => {
  return {
    type: GET_PLAN_SUCCESS,
    payload: response,
  };
};

export const getPlanError = (error: any): GetPlanErrorAction => {
  return {
    type: GET_PLAN_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Plan

export const addPlan = (
  request: CreatePlanRequest,
  history: History
): AddPlanAction => {
  return {
    type: ADD_PLAN,
    payload: { request, history },
  };
};

export const addPlanSuccess = (plan: PlanDto): AddPlanSuccessAction => {
  return {
    type: ADD_PLAN_SUCCESS,
    payload: plan,
  };
};

export const addPlanError = (error: any): AddPlanErrorAction => {
  return {
    type: ADD_PLAN_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Plan

export const updatePlan = (
  id: string,
  request: UpdatePlanRequest,
  history: History
): UpdatePlanAction => {
  return {
    type: UPDATE_PLAN,
    payload: { id, request, history },
  };
};

export const updatePlanSuccess = (plan: PlanDto): UpdatePlanSuccessAction => {
  return {
    type: UPDATE_PLAN_SUCCESS,
    payload: plan,
  };
};

export const updatePlanError = (error: any): UpdatePlanErrorAction => {
  return {
    type: UPDATE_PLAN_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Plan Image

export const uploadPlanImage = (
  file: File,
  localId: number,
  planId?: string
): UploadPlanImageAction => {
  return {
    type: UPLOAD_PLAN_IMAGE,
    payload: { file, planId, localId },
  };
};

export const uploadPlanImageSuccess = (
  localId: number,
  media: MediaDto
): UploadPlanImageSuccessAction => {
  return {
    type: UPLOAD_PLAN_IMAGE_SUCCESS,
    payload: { localId, media },
  };
};

export const uploadPlanImageError = (
  localId: number,
  error: any
): UploadPlanImageErrorAction => {
  return {
    type: UPLOAD_PLAN_IMAGE_ERROR,
    payload: { localId, error },
  };
};

export const uploadPlanImageProgress = (
  localId: number,
  progress: any
): UploadPlanImageProgressAction => {
  return {
    type: UPLOAD_PLAN_IMAGE_PROGRESS,
    payload: { localId, progress },
  };
};

export const removeUploadedPlanImage = (
  localId: number
): RemoveUploadedPlanImageAction => ({
  type: REMOVE_UPLOADED_PLAN_IMAGE,
  payload: localId,
});

export const setInitialPlanImages = (
  images: any
): SetInitialPlanImagesAction => ({
  type: SET_INITIAL_PLAN_IMAGES,
  payload: images,
});

//#endregion

//#region Delete Plan

export const deletePlanConsent = (id: string): DeletePlanConsentAction => {
  return {
    type: DELETE_PLAN_CONSENT,
    payload: id,
  };
};

export const deletePlan = (id: string, history: History): DeletePlanAction => {
  return {
    type: DELETE_PLAN,
    payload: { id, history },
  };
};

export const deletePlanSuccess = (): DeletePlanSuccessAction => {
  return {
    type: DELETE_PLAN_SUCCESS,
    payload: null,
  };
};

export const deletePlanError = (error: any): DeletePlanErrorAction => {
  return {
    type: DELETE_PLAN_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle Plan State

export const togglePlanState = (
  id: string,
  history: History
): TogglePlanStateAction => {
  return {
    type: TOGGLE_PLAN_STATE,
    payload: { id, history },
  };
};

export const togglePlanStateSuccess = (
  id: string
): TogglePlanStateSuccessAction => {
  return {
    type: TOGGLE_PLAN_STATE_SUCCESS,
    payload: { id },
  };
};

export const togglePlanStateError = (
  error: any
): TogglePlanStateErrorAction => {
  return {
    type: TOGGLE_PLAN_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region add edit plan modal
export const toggleAddEditPlanModal = (): ToggleAddEditPlanModalAction => {
  return {
    type: TOGGLE_ADD_EDIT_PLAN_MODAL,
    payload: null,
  };
};
//#endregion

//#region Get Purchasable Plans for Student by providing course and grade id

export const getPurchaseablePlansForStudent = (
  courseId: string,
  gradeId: string,
  userId: string
): GetPurchaseablePlansForStudentAction => {
  return {
    type: GET_PURCHASEABLE_PLANS_FOR_STUDENT,
    payload: { courseId, gradeId, userId },
  };
};

export const getPurchaseablePlansForStudentSuccess = (
  response: SelectListDto[]
): GetPurchaseablePlansForStudentSuccessAction => {
  return {
    type: GET_PURCHASEABLE_PLANS_FOR_STUDENT_SUCCESS,
    payload: response,
  };
};

export const getPurchaseablePlansForStudentError = (
  error: any
): GetPurchaseablePlansForStudentErrorAction => {
  return {
    type: GET_PURCHASEABLE_PLANS_FOR_STUDENT_ERROR,
    payload: error,
  };
};

export const resetPurchaseablePlansForStudent =
  (): ResetPurchaseablePlansForStudentAction => {
    return {
      type: RESET_PURCHASEABLE_PLANS_FOR_STUDENT,
      payload: {},
    };
  };

//#endregion
